@if (dtypeForm) {
  <div class="flex flex-col md:flex-row w-full">
    @if (showBOPreview) {
      <dtype-component-list class="w-full" [ngClass]="isForm() ? 'md:w-2/3' : ''" [dtypeForm]="dtypeForm"></dtype-component-list>
    }
    @if (isForm()) {
      <div class="flex flex-col items-center" [ngClass]="showBOPreview ? 'w-full md:w-1/3' : 'w-full'">
        <div class="flex items-center gap-2">
          <mat-button-toggle-group [(ngModel)]="ionicMode" (change)="changeMode()">
            <mat-button-toggle checked="true" value="md">Android</mat-button-toggle>
            <mat-button-toggle value="ios">iOS</mat-button-toggle>
          </mat-button-toggle-group>
          <button mat-icon-button (click)="reloadIframe()">
            <mat-icon [svgIcon]="'mat_outline:refresh'"></mat-icon>
          </button>
        </div>
        <div class="flex items-center justify-center">
          <div class="mt-4 font-semibold tracking-tight text-secondary w-2/3">{{ 'devicePreviewWarning' | transloco }}</div>
        </div>
        <!-- <p class="p-4">{{ 'devicePreviewWarning' | transloco }}</p> -->
        @if (ionicMode === 'md') {
          <div class="preview-device md">
            <figure>
              @if (previewDeviceUrl) {
                <iframe id="deviceIframe" loading="lazy" importance="low" [src]="previewDeviceUrl"></iframe>
              }
            </figure>
          </div>
        }
        @if (ionicMode === 'ios') {
          <div class="preview-device ios">
            <figure>
              <!-- <svg class="ios-notch" viewBox="0 0 219 31">
              <path d="M0 1V0h219v1a5 5 0 0 0-5 5v3c0 12.15-9.85 22-22 22H27C14.85 31 5 21.15 5 9V6a5 5 0 0 0-5-5z" fill-rule="evenodd"></path>
            </svg> -->
            @if (previewDeviceUrl) {
              <iframe id="deviceIframe" loading="lazy" importance="low" [src]="previewDeviceUrl"></iframe>
            }
          </figure>
        </div>
      }
    </div>
  }
</div>
}